import { UseFormReturn } from "react-hook-form";
import { UnsavedChangesPrompt } from "@velocity-ehs/component-library";
import { ContractingCompany, IPersonUserForm } from "../Person";
import { UserDetails } from "./Cards/UserDetails";
import { useHistory } from "react-router";
import { useGetContractingCompanies } from "../../../../hooks/useGetContractingCompanies";
import { ContractingCompanySidebar } from "../../ContractingCompanies/ContractingCompanySidebar";
import { useState } from "react";

interface PersonUserFormProps {
  formMethods: UseFormReturn<any, any>;
  onSubmit: (formValues: IPersonUserForm) => void;
}

const PersonUserForm = ({ formMethods, onSubmit }: PersonUserFormProps) => {
  const history = useHistory();
  const { contractingCompanies } = useGetContractingCompanies();
  const [showContractingCompanySlider, setShowContractingCompanySlider] =
    useState<boolean>(false);

  const closeSlider = () => {
    setShowContractingCompanySlider(false);
  };

  const openSlider = () => {
    setShowContractingCompanySlider(true);
  };
  const handleSliderSubmit = (createdCompany: ContractingCompany) => {
    contractingCompanies.push(createdCompany);
    formMethods.setValue("contractingCompany", createdCompany);
  };
  const { formState, handleSubmit } = formMethods;

  const handleOnSubmit = (values: IPersonUserForm) => {
    formMethods.reset(values);

    return onSubmit(values);
  };

  return (
    <>
      <form id="personUserForm" onSubmit={handleSubmit(handleOnSubmit)}>
        <>
          <UserDetails
            formMethods={formMethods}
            contractingCompanies={contractingCompanies}
            openSlider={openSlider}
          />
        </>
      </form>
      <ContractingCompanySidebar
        isVisible={showContractingCompanySlider}
        closeSlider={closeSlider}
        updateSelectedContractingCompany={handleSliderSubmit}
      />
      <UnsavedChangesPrompt
        isDirty={formMethods.formState.isDirty}
        history={history}
      />
    </>
  );
};

export { PersonUserForm };
